import type { ParsedVideoUrl } from '@year13/content-validator';

import { VIDEO_PROVIDER } from '@year13/content-validator';

export type { ParsedVideoUrl, VideoProviderName } from '@year13/content-validator';
export { parseVideoUrl, VIDEO_PROVIDER } from '@year13/content-validator';

interface VideoEmbedOptions {
  autoplay?: boolean;
  /** Lets YouTube's IFrame Player API control the embed. Vimeo's player needs no flag. */
  jsApi?: boolean;
}

export const videoEmbedUrl = (parsed: ParsedVideoUrl, options: VideoEmbedOptions = {}): string => {
  const params = new URLSearchParams();
  if (parsed.provider === VIDEO_PROVIDER.Vimeo && parsed.hash) {
    params.set('h', parsed.hash);
  }
  if (options.autoplay) {
    params.set('autoplay', '1');
  }
  if (options.jsApi && parsed.provider === VIDEO_PROVIDER.YouTube) {
    params.set('enablejsapi', '1');
  }
  const base = parsed.provider === VIDEO_PROVIDER.Vimeo
    ? `https://player.vimeo.com/video/${parsed.id}`
    : `https://www.youtube-nocookie.com/embed/${parsed.id}`;
  const query = params.toString();
  return query ? `${base}?${query}` : base;
};
